import { render, staticRenderFns } from "./PromoCodeTable.vue?vue&type=template&id=3f81b9c2&"
import script from "./PromoCodeTable.vue?vue&type=script&lang=js&"
export * from "./PromoCodeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports